/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/customers/customer-address
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import { shopifyCountryCodeEnumOptions } from "./constants";
import {
  ShopifyCustomerAddressKey,
  ShopifyCustomerAddressToCustomerKey,
  ShopifyCustomerAddressToShopKey,
  ShopifyCustomerKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyCustomerAddressKey,
  "2022-01": {
    name: "Shopify Customer Address",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Address 1",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "address1" } },
      },
      {
        name: "Address 2",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "address2" } },
      },
      {
        name: "City",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "city" } },
      },
      {
        name: "Company",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "company" } },
      },
      {
        name: "Country",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "country" } },
      },
      {
        name: "Country Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "country_code" } },
      },
      {
        name: "Country Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "country_name" } },
      },
      {
        name: "Shopify Customer",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCustomerAddressToCustomerKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "customer_id" } },
        configuration: {
          relatedModelKey: ShopifyCustomerKey,
        },
      },
      {
        name: "First Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "first_name" } },
      },
      {
        name: "Last Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "last_name" } },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "name" } },
      },
      {
        name: "Phone",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "phone" } },
      },
      {
        name: "Province",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "province" } },
      },
      {
        name: "Province Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "province_code" } },
      },
      {
        name: "ZIP Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "zip" } },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCustomerAddressToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "customer" },
  },
  "2025-04": {
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "id",
            graphQLFieldKey: "id",
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
      },
      {
        name: "Address 1",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "address1",
            graphQLFieldKey: "address1",
            protectedCustomerData: ["address"],
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
      },
      {
        name: "Address 2",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "address2",
            graphQLFieldKey: "address2",
            protectedCustomerData: ["address"],
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
      },
      {
        name: "City",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "city",
            graphQLFieldKey: "city",
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
      },
      {
        name: "Company",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "company",
            graphQLFieldKey: "company",
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
      },
      {
        name: "Country",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "country",
            graphQLFieldKey: "country",
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
      },
      {
        name: "Country Code",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "country_code",
            graphQLFieldKey: "countryCodeV2",
            isShopifyEnum: true,
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: shopifyCountryCodeEnumOptions,
        },
      },
      {
        name: "Country Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "country_name",
            graphQLFieldKey: "countryName",
            skipGraphQLSelection: true,
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
            deprecated: true,
          },
        },
      },
      {
        name: "Shopify Customer",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCustomerAddressToCustomerKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "customer_id",
            graphQLFieldKey: "customerId",
            skipGraphQLSelection: true,
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
        configuration: {
          relatedModelKey: ShopifyCustomerKey,
        },
      },
      {
        name: "First Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "first_name",
            graphQLFieldKey: "firstName",
            protectedCustomerData: ["name"],
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
      },
      {
        name: "Last Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "last_name",
            graphQLFieldKey: "lastName",
            protectedCustomerData: ["name"],
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "name",
            graphQLFieldKey: "name",
            protectedCustomerData: ["name"],
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
      },
      {
        name: "Phone",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "phone",
            graphQLFieldKey: "phone",
            protectedCustomerData: ["phone"],
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
      },
      {
        name: "Province",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "province",
            graphQLFieldKey: "province",
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
      },
      {
        name: "Province Code",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "province_code",
            graphQLFieldKey: "provinceCode",
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
      },
      {
        name: "ZIP Code",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "zip",
            graphQLFieldKey: "zip",
            protectedCustomerData: ["address"],
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
      },
      {
        name: "Coordinates Validated",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "coordinatesValidated" } },
      },
      {
        name: "Formatted",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "formatted",
            protectedCustomerData: ["address"],
          },
        },
      },
      {
        name: "Formatted Area",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "formattedArea" } },
      },
      {
        name: "Latitude",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "latitude", protectedCustomerData: ["address"] },
        },
      },
      {
        name: "Longitude",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "longitude", protectedCustomerData: ["address"] },
        },
      },
      {
        name: "Timezone",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "timeZone" } },
      },
      {
        name: "Validation Result Summary",
        fieldType: FieldType.Enum,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "validationResultSummary", isShopifyEnum: true } },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [{ name: "ERROR" }, { name: "NO_ISSUES" }, { name: "WARNING" }],
        },
      },
    ],
    syncConfig: { type: "graphql_sublist", parent: "customers", resource: "customer.addressesV2" },
  },
};

export const ShopifyCustomerAddress = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
